module.exports = __webpack_public_path__ + "app/community/community-layout-3X1i31ui.html";